//import React, { useState, useEffect, useContext } from 'react'
//import { createMarkup, setParams } from './utils'
//import { apiDefaults, apiFetch, parseJSON } from  './api'
//import { Link, Route } from 'react-router-dom'
//import './Content.css'
//import Item from './Item'
//import Loading from './components/Loading/Loading'
//import SearchForm from './components/Search/SearchForm'
//
//const Content = ({match: { params: { id: contentID } }, match}) => {
//    const [item, setItem] = useState(undefined)
//    const [isLoading, setIsLoading] = useState(true)
//
//  const fetchContent = async(controller) => {
//    setIsLoading(true)
//    const url = new URL(`${apiDefaults.project}/items/ic1ty_content`, apiDefaults.url)
//    //const url = new URL(`/categories`, apiDefaults.url)
//
//    const params = [
//      [`filter[id][eq]`, `${contentID}`],
//    ]
//    
//    setParams(url, params)
//
//    const response = await apiFetch(url, controller.signal)
//    const json = await response.json()
//    setItem(json.data)
//    setIsLoading(false)
//  }
//
//  useEffect(() => {
//    const myController = new AbortController();
//    fetchContent(myController)
//    return () => myController.abort()
//  }, [contentID])
//
//    if (isLoading) {
//        return <Loading/>
//    }
//
//
//    if (item) {
//        return (
//        <>
//          <SearchForm />
//          {item && (item.catid || item.id) && <Link to={`/category/${item.catid}`}>Kategorie</Link>}
//          <Item id={0} introtext={createMarkup(item[0].introtext)} title={item[0].title} />
//        </>
//        )} 
//}
//
//export default Content

import React, { useState, useEffect, useContext } from 'react'
import { createMarkup, setParams } from './utils'
import { apiDefaults, apiFetch, parseJSON } from  './api'
import { Link, Route } from 'react-router-dom'
import useAxios from 'axios-hooks'

import './Content.css'
import Item from './Item'
import Loading from './components/Loading/Loading'
import Login from './components/Authentication/Login'

const Content = ({ match: { params: { id: contentID } }, match, history }) => {
    const [item, setItem] = useState(undefined)

  const [{ data, loading, error }] = useAxios(
    {
      url: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/content/${contentID}`,
      method: 'GET',
      withCredentials: true,
    }
  )

  if (error) {
    if (error.response.status === 401) {
      history.replace('/login', {
        goBack: true,
        prevLocation: history.location
      })
      return null
    }

    return <div>Chyba zobrazení, chybu jsme zaznamenali</div> 
  }

    if (loading) {
        return <Loading/>
    }

    if (data) {
      const { category_id, id, introtext, title } = data
        return (
        <>
          <Item id={0} introtext={createMarkup(introtext)} title={title} />
        </>
        )
    } 
}

export default Content
